import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import RejectIcon from "../../../assets/images/RejectIcon.svg";
import approved from "../../../assets/images/approved.svg";
import delivaApiService from "../../../common/services/apiService";
import ApprovedChecked from "../../../assets/images/CheckedApproved.png";
import validateInput from "../../../common/validations/validateProofs";
import CustomKycModal from "../../common/CustomKycModal";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const DeliveryBankDetail = ({ profileDetail, getDeliveryAgentProfile }) => {
  const location = useLocation();
  const history = useHistory();

  const userId = location?.state?.item?.userId;
  const [showBankDetailsApproveModal, setShowBankDetailsApproveModal] =
    useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [kycRejectRemark, setKycRejectRemark] = useState("");

  const approveBankDetails = () => {
    setShowLoader(true);

    delivaApiService("approveBankDetails", {
      userId: profileDetail?.userId,
      bankDetailsApprovedByAdmin: true,
    })
      .then((response) => {
        setShowLoader(false);
        if (response?.data?.status === 200) {
          setShowBankDetailsApproveModal(false);
          setSuccessModal(true);
          getDeliveryAgentProfile(userId);
          const pathMap = {
            "/deliveryPartnerProfile/bankdatail": "/deliveryPartnerList",
            "/partner/verify": "/verification/3",
          };

          const redirectPath = pathMap[location.pathname];
          if (redirectPath) {
            history.push({ pathname: redirectPath });
          }
        }
      })
      .catch(() => {
        setShowLoader(false);
      });
  };

  const submitReject = () => {
    setShowLoader(true);
    const { errors, isValid } = validateInput(
      { kycRejectRemark },
      "kycRejectRemark"
    );
    if (isValid) {
      let data = {
        rejectionDetail: kycRejectRemark,
        userId,
      };

      delivaApiService("rejectBankDetails", data)
        .then((response) => {
          setShowLoader(false);
          if (response.data.status === 200) {
            setShowRejectModal(false);
            getDeliveryAgentProfile(userId);
          }
        })
        .catch(() => {
          setShowLoader(false);
        });
    } else {
      setErrors(errors);
    }
  };

  const onChange = (event) => {
    const { value } = event.target;
    setKycRejectRemark(value);
    const { errors } = validateInput(
      { kycRejectRemark: value },
      "kycRejectRemark"
    );
    setErrors(errors);
  };

  return (
    <div className="details-wrap mb-4">
      <Row noGutters>
        <Col md={12} lg={12}>
          <h5 className="px-4">Banking Details</h5>
          <hr />
        </Col>
      </Row>
      <Row className="px-4 gy-3">
        <Col md={6} lg={4}>
          <div className="pr-wrap">
            <h5 className="font-weight-normal color-grey fs18">Full Name</h5>
            <h5 className="fs18 font-weight-normal">
              {profileDetail?.bankingDetails?.fullName}
            </h5>
          </div>
        </Col>
        <Col md={6} lg={4}>
          <div className="">
            <h5 className="font-weight-normal color-grey fs18">
              Account Number
            </h5>
            <h5 className="fs18 font-weight-normal">
              {profileDetail?.bankingDetails?.accountNumber}
            </h5>
          </div>
        </Col>
        <Col md={6} lg={4}>
          <div className="">
            <h5 className="font-weight-normal color-grey fs18">Bank</h5>
            <h5 className="fs18 font-weight-normal">
              {profileDetail?.bankingDetails?.bankName}
            </h5>
          </div>
        </Col>

        {/* {profileDetail?.bankingDetails?.bankDetailsApprovedByAdmin && ( */}
        <Col md={6} lg={4}>
          <div className="">
            <h5 className="font-weight-normal color-grey fs18">Status</h5>
            <h5
              className={`fs18 font-weight-normal ${profileDetail?.bankingDetails?.status === "Pending"
                ? "textOrange"
                : profileDetail?.bankingDetails?.status === "Verified"
                  ? "textGreen"
                  : profileDetail?.bankingDetails?.status === "Rejected"
                    ? "textRed" : profileDetail?.bankingDetails?.status === "Verified by paystack" ?
                      "textGreen"
                      : ""
                }`}
            >
              {" "}
              {profileDetail?.bankingDetails?.status}
            </h5>
          </div>
        </Col>

      </Row>
      <hr />
      {!profileDetail?.bankingDetails?.status === "Verified by paystack" && <div className="d-flex mt-4 gap-3 mb-1 justify-content-center">
        <button
          className="df-button success"
          disabled={profileDetail?.bankingDetails?.bankDetailsApprovedByAdmin}
          onClick={() => setShowBankDetailsApproveModal(true)}
        >
          Approve
        </button>
      </div>
      }

      {successModal && (
        <CustomKycModal
          show={successModal}
          onHide={() => setSuccessModal(false)}
          icon={approved}
          heading="Approved"
          headingClass="lightGreenText my-4"
          text={`${profileDetail.name} #${profileDetail.userId} details are approved`}
          buttons={[
            {
              label: "Back",
              className: "b1-btn min-w-80",
              onClick: () => setSuccessModal(false),
            },
          ]}
        />
      )}

      {showBankDetailsApproveModal && (
        <CustomKycModal
          show={showBankDetailsApproveModal}
          onHide={() => setShowBankDetailsApproveModal(false)}
          icon={ApprovedChecked}
          heading="Are you sure to approve this request?"
          headingClass="color-green my-4 fs-22 nowrap"
          buttons={[
            {
              label: "No",
              className: "cancel-btn mr-4 min-w-80",
              onClick: () => setShowBankDetailsApproveModal(false),
            },
            {
              label: "Yes",
              className: "b1-btn min-w-80",
              disbaled: showLoader,
              onClick: approveBankDetails,
            },
          ]}
        />
      )}

      {showRejectModal && (
        <CustomKycModal
          show={showRejectModal}
          onHide={() => setShowRejectModal(false)}
          icon={RejectIcon}
          iconClass="img-fluid reject-img pointer"
          heading="Are you sure to Reject this Bank verification?"
          headingClass="color-red my-4 fs-22"
          children={
            <Form.Group controlId="exampleForm.ControlTextarea1">
              <Form.Label className="color-head">
                Rejection for rejection
              </Form.Label>
              <Form.Control
                as="textarea"
                rows="3"
                name="kycRejectRemark"
                value={kycRejectRemark}
                onChange={onChange}
                minLength='100'
              />
              {errors?.kycRejectRemarkError && (
                <span className="text-danger">
                  {errors?.kycRejectRemarkError}
                </span>
              )}
            </Form.Group>
          }
          buttons={[
            {
              label: "No",
              className: "cancel-btn mr-4 min-w-80",
              onClick: () => {
                setErrors({});
                setKycRejectRemark("");
                setShowRejectModal(false);
              },
            },
            {
              label: "Yes",
              className: "b1-btn min-w-80",
              disbaled: showLoader,
              onClick: submitReject,
            },
          ]}
        />
      )}
    </div>
  );
};

export default DeliveryBankDetail;
